import { render, staticRenderFns } from "./Billing.vue?vue&type=template&id=8ff070aa&"
import script from "./Billing.vue?vue&type=script&lang=ts&"
export * from "./Billing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports